

export const screen = "shell";
export const css = "";
export const meta = {};

export function mount(app, __params) {

  const el_n1 = document.createElement('div');
  el_n1.className = "mu-shell";
  { if (!document.getElementById('mu-a11y-css')) { const st = document.createElement('style'); st.id = 'mu-a11y-css'; st.textContent = '.mu-skip-link{position:absolute;left:-9999px;top:8px;z-index:1000;padding:8px 16px;border-radius:6px;background:#111;color:#fff;text-decoration:none}.mu-skip-link:focus{left:8px}#mu-main:focus{outline:none}'; document.head.appendChild(st); } const sk = document.createElement('a'); sk.href = '#mu-main'; sk.className = 'mu-skip-link'; sk.textContent = 'Skip to content'; el_n1.appendChild(sk); }
  app.appendChild(el_n1);
  const __outlet = document.createElement('div');
  __outlet.className = 'muten-outlet';
  el_n1.appendChild(__outlet);

  return __outlet;
}
